import React from 'react';

import { ReactComponent as ArrownDownIcon } from 'pages/Teachers/Assignments/MathAssignmentCreateFlow/assets/arrow-down.svg';
import { ReactComponent as PersonIcon } from 'pages/Teachers/Assignments/MathAssignmentCreateFlow/assets/person.svg';

import styles from './styles.module.scss';

const ClassSelector = ({
  sections,
  selectedSections,
  onAdd,
  onRemove,
  isLoading
}) => {
  const handleClassSelect = (e) => {
    const section = sections.find((s) => s.id === Number(e.target.value));
    if (section) onAdd({ section: section });
  };

  return (
    <div className={styles.fieldSection}>
      <div className={styles.fieldLabel}>
        <PersonIcon /> <span>Assign To Class</span>
      </div>

      <div className={styles.selectWrapper}>
        <select
          value=""
          onChange={(e) => {
            handleClassSelect(e);
          }}
          className={styles.inputField}
        >
          <option value="" disabled>
            {isLoading ? 'Loading classes...' : 'Select a class...'}
          </option>
          {sections.map((section) => (
            <option key={section.id} value={section.id}>
              {section.name}
            </option>
          ))}
        </select>
        <ArrownDownIcon className={styles.chevron} />
      </div>

      <div className={styles.selectedSectionsList}>
        {selectedSections.map((section) => (
          <div key={section.id} className={styles.selectedSectionRow}>
            <span className={styles.sectionName}>{section.name}</span>
            <button
              type="button"
              className={styles.removeSectionBtn}
              onClick={() => onRemove({ id: section.id })}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClassSelector;
